module.exports = __webpack_public_path__ + "img/20210906-1630911099112684.587bed50.jpg";